<template>
    <div>
        <div class="row" v-if="isReady">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <div class="widget-title">
                            <h3>Blog Ekle</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="category">Kategori</label>
                                    <select class="form-control custom-input" v-model="category">
                                        <option value="" selected disabled hidden>Seçiniz...</option>
                                        <option
                                                v-for="category in categories"
                                                :key="category.id"
                                                :value="category.id"
                                        >{{ category.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="cover">Kapak Resmi</label>
                                    <input type="file" @change="onCover" class="form-control custom-input">
                                    <div v-if="display_image" class="image_content">
                                        <img :src="display_image" alt="" class="display-img">
                                        <button type="button" class="btn btn-danger trash-btn" @click="destroyCover()">
                                            <i class="fa fa-trash"></i></button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Blog Başlığı</label>
                                    <input type="text" v-model="title" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="slug">SEF Link</label>
                                    <input type="text" v-model="slug" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="meta_keywords">Meta Keywords</label>
                                    <textarea v-model="meta_keywords" class="form-control custom-input"
                                              rows="7"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="meta_description">Meta Description</label>
                                    <textarea v-model="meta_description" class="form-control custom-input"
                                              rows="7"></textarea>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="content">İçerik</label>
                                    <vue-editor v-model="content" class="editor"></vue-editor>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="images">Resim Galerisi
                                        <small>(Birden fazla seçim yapılabilir.)</small>
                                    </label>
                                    <input type="file" class="form-control custom-input" @change="gallery" multiple>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="is_constant">Ana Sayfada Gösterilsin mi?</label>
                                    <select class="form-control custom-input" v-model="is_constant">
                                        <option value="" selected hidden disabled>Seçiniz...</option>
                                        <option value="1">Evet</option>
                                        <option value="0">Hayır</option>
                                    </select>
                                </div>
                            </div>

                            <draggable v-model="images">
                                <transition-group>
                                    <div class="col-md-4 galleryImage" v-for="image in images" :key="image.id">
                                        <img :src="image.filename" alt class="img-responsive">
                                        <button class="btn btn-danger trash-btn" @click="destroyImage(image)"><i
                                                class="fa fa-trash"></i></button>
                                    </div>
                                </transition-group>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <error :errors="validationErrors" v-if="validationErrors"></error>
                        <div style="width: 100%;" class="text-center" >
                            <button class="btn btn-edit" @click="updateData">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VueEditor} from "vue2-editor";
    import draggable from 'vuedraggable';
    import Error from "@/components/layouts/Error";

    export default {
        components: {VueEditor, draggable, Error},

        data() {
            return {
                isReady: false,
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}]
                ],
                id: this.$route.params.id,
                display_image: '',
                title: "",
                content: '',
                cover: null,
                category: '',
                categories: [],
                meta_keywords: '',
                meta_description: '',
                is_constant: '',
                api: "blogs/",
                images: [],
                validationErrors: '',
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            gallery(e) {
                let selectedFlies = e.target.files;
                if (!selectedFlies.length) {
                    return false
                }
                for (let i = 0; i < selectedFlies.length; i++) {
                    this.images.push(selectedFlies[i]);
                }
                // console.log(this.images)
            },
            onCover(event) {
                this.cover = event.target.files[0]
                // console.log(this.cover)
            },
            getData() {
                this.$Progress.start();
                this.axios.get(this.api + this.id + "/edit").then(response => {
                    this.title = response.data.item.title;
                    this.content = response.data.item.content;
                    this.slug = response.data.item.slug;
                    this.display_image = response.data.item.cover;
                    this.images = response.data.item.images;
                    this.meta_keywords = response.data.item.meta_keywords;
                    this.meta_description = response.data.item.meta_description;
                    this.category = response.data.item.category_id;
                    this.categories = response.data.categories;
                    this.is_constant = response.data.item.is_constant;
                    this.$Progress.finish();
                }).then(() => {
                    this.isReady = true;
                });
            },
            updateData() {
                this.$Progress.start();
                var data = {
                    category: this.category || '',
                    title: this.title || '',
                    slug: this.slug || '',
                    content: this.content || '',
                    meta_keywords: this.meta_keywords || '',
                    meta_description: this.meta_description || '',
                    is_constant: this.is_constant || '',
                }

                const formData = new FormData();
                if (this.cover) {
                    formData.append('cover', this.cover)
                }
                if (this.images.length > 0) {
                    for (let i = 0; i < this.images.length; i++) {
                        formData.append('images[]', this.images[i])
                    }
                }
                Object.keys(data).map(e => {
                    formData.append(e, data[e])
                })
                formData.append('_method', 'PUT')
                this.axios
                    .post(this.api + this.id, formData)
                    .then(response => {
                        if (response.status == 200) {
                            this.$Progress.finish();
                        }
                    }).catch(error => {
                    this.$Progress.finish();
                    if (error.response.status == 422) {
                        this.validationErrors = error.response.data.errors;
                    }else if ( error.response.status == 500 ) {
                        this.validationErrors = { message : ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!'] };
                    }
                });
            },

            destroyCover() {
                this.axios.post('blog/cover-destroy/' + this.id).then(response => {
                    if (response.status == 200) {
                        this.display_image = '';
                    }
                })
            },

            destroyImage(image) {
                this.$Progress.start();
                this.axios.post('blog/image-destroy/' + image.id)
                    .then(response => {
                        if (response.status == 200) {
                            var index = this.images.indexOf(image);
                            this.images.splice(index, 1);
                            this.$Progress.finish();
                        }
                    })
            },
        },
        computed: {
            slug: {
                get() {
                    return window.Slug(this.title.toLowerCase())
                },
                set() {
                    let slug = window.Slug(this.title)
                    return slug
                }
            }
        }
    };
</script>

<style scoped>
    .galleryImage {
        margin-bottom: 10px;
        position: relative;
    }

    .galleryImage img {
        border-radius: 6px;
        opacity: 0.7;
    }

    .galleryImage img:hover {
        transition: 0.5s;
        opacity: 1;
    }

    .display-img {
        width: 250px;
    }

    .trash-btn {
        position: absolute;
        top: 15px;
        right: 25px;
    }

    .image_content {
        position: relative;
    }
</style>
